/// <amd-module name="Test/TestPlansHubRefresh/TestCaseResultsPanel/Redux/TestCaseResultsPanelReducer" />
import produce from "immer";
import {
    TestCaseResultsPanelActions,
    TestCaseResultsPanelActionsTypes
} from "Test/TestPlansHubRefresh/TestCaseResultsPanel/Redux/TestCaseResultsPanelActions";
import { IResultsPanelState, IResultsPanelTableItem } from "Test/TestPlansHubRefresh/TestCaseResultsPanel/Redux/TestCaseResultsPanelContracts";
import { getTestCaseResultsForTable } from "Test/TestPlansHubRefresh/TestCaseResultsPanel/Utils";

export function TestCaseResultsPanelReducer(state: IResultsPanelState, action: TestCaseResultsPanelActions): IResultsPanelState {
    state = state || ({} as IResultsPanelState);

    return produce(state, (draftState: IResultsPanelState) => {
        switch (action.type) {
            case TestCaseResultsPanelActionsTypes.fetchTestResultsSucceeded:
                var testCaseResults: IResultsPanelTableItem[] = [];
                if (action.payload.data) {
                    testCaseResults = getTestCaseResultsForTable(action.payload.data.results);
                }

                draftState.testCaseResults = testCaseResults;
                draftState.loadingInProgress = false;
                break;

            case TestCaseResultsPanelActionsTypes.loadingInProgress:
                draftState.loadingInProgress = true;
                break;

            default:
                break;
        }
    });
}
